<template>  
  <div>
    <card card-body-classes="table-full-width px-3">
      <div slot="header">
        <h4 class="card-title f-20-mobile">Aniversariantes</h4>
      </div>
      <div class="row">
        <div class="col-md-12">
          <router-link to="/clientes" class="btn btn-info" tag="a">
            Exibir Clientes
          </router-link>
        </div>

        <div class="col-12 col-md-9">
          <label style="display: block">Selecione o Mês</label>
          <v-select @input="filtrar" :options="meses" v-model="mesAniversario" style="width: 200px; display: inline-block"></v-select>
        </div>
      </div>
      <div class="mb-3">
        <div v-for="aniversariante of aniversariantes" class="row py-2 px-2 bordered-block-table only-mobile" style="position: relative;">
          <div class="col-7">
            <span style="color: #000; font-weight: bold; font-size: 14px;">{{ aniversariante.nome_razao }}</span>
            <br>
          </div>
          <div class="col-5 text-right">
            <span style="color: #666; font-size: 14px;">{{ aniversariante.data_nascimento | moment("DD/MM/YYYY") }}</span>
          </div>
          <div class="col-12 mt-1">
            <span style="color: #666; font-size: 14px;">Telefone: {{ aniversariante.telefone }}</span>           
            <br>
            <span style="color: #666; font-size: 14px;">E-mail: {{ aniversariante.email }}</span>           
          </div>
        </div>
      </div>

      <table class="table table-striped hidden-mobile">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Data de Nascimento</th>
            <th>E-mail</th>
            <th>Telefone</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="anversariante of aniversariantes">
            <td>{{ anversariante.nome_razao}}</td>
            <td>{{ anversariante.data_nascimento | moment("DD/MM/YYYY") }}</td>
            <td>{{ anversariante.email }}</td>
            <td>{{ anversariante.telefone  }}</td>
          </tr>
          <tr v-if="aniversariantes && aniversariantes.length === 0">
            <td colspan="4" class="text-center">Nenhum aniversariante encontrado no mês</td>
          </tr>
        </tbody>
      </table>
    </card>
  </div>
</template>

<script>

import { Card } from 'src/components'
import moment from 'moment'
import ClienteService from '@/services/ClienteService.js'


export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        mesAniversario:{'label':moment().locale('pt-br').format('MMMM'),'value':this.$moment().format('M')},
        labelAniversariantes:moment().locale('pt-br').format('MMMM'),  
        meses:[],
        aniversariantes:[],
      }
    },
    methods: {
      filtrar() {
        let loader = this.$loading.show()

        ClienteService.aniversariantes('?mes='+this.mesAniversario.value).then(aniversariantes => {
          loader.hide()

          aniversariantes.data.sort((a, b) => {
            if (a.data_nascimento.substr(8, 2) < b.data_nascimento.substr(8, 2)) return -1
            return a.name > b.name ? 1 : 0
          })
          
          this.aniversariantes = aniversariantes.data;
        })
        .catch(err => {
          loader.hide()
        });
      },
    },
    mounted() {
      for(let i =0;i<=11;i++){
        this.meses.push({'label':moment().locale("pt-br").month(i).format('MMMM'),'value':i+1});
      }
      this.filtrar();
    }
}
</script>